import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-user-location-permission-dialog',
  templateUrl: './user-location-permission-dialog.component.html',
  styleUrl: './user-location-permission-dialog.component.scss',
})
export class UserLocationPermissionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UserLocationPermissionDialogComponent>
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    // Handle action to open location settings
    this.dialogRef.close();
  }
}
